export const MULTI_PDF_REPORT_KEYS = {
  MULTI_PDF: 'MULTI_PDF',
  USER_DEFINED: 'USER_DEFINED',
  STANDARD_LIBRARY: 'STANDARD_LIBRARY',
  LOCAL_LIBRARY: 'LOCAL_LIBRARY'
};